export const regionais = ["NORTE", "NORDESTE", "CENTRO-OESTE", "SUDESTE", "SUL"];
